import React, { Fragment, } from 'react';
import { Grid, makeStyles, CircularProgress, Dialog, DialogTitle, DialogContent, Button, Backdrop, Avatar } from '@material-ui/core';
import { palette, msmSwalExito, msmSwalError } from 'configurations/styles/theme';
import { httpCore, clientBackendPDF } from 'configurations/axios'
import { getRUCEmpresa, getSub } from 'redux/actions/userActions';
import { useSelector, useDispatch } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import pdfIcon from 'assets/icons/pdf.png'
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import { ConfirmAlert, iconsAlert, ErrorsAlert } from 'utils/AlertsCustom';
import { selectedResourceAction } from "redux/actions/resourcesActions";
import { checkPreRequirements, } from 'widgets/menu/preRedirect';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.primary,
        margin: theme.spacing(1),
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '1%',
        borderStyle: 'solid',
        boxShadow: "5px 3px 3px #aaaaaa",
        borderRadius: '8px',
        justifyContent: 'center',
        borderWidth: '1px'
    },
    formControl: {
        marginTop: theme.spacing(0),
        minWidth: 120,

    },
    divForm: {
        marginBottom: '1%',
        textAlign: 'justify',
    },

    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
    msgDialog: {
        padding: "2%"
    },
    btnReport: {
        borderRadius: "8px",
        borderStyle: "dashed",
        borderWidth: "1px",
        borderColor: palette.primary.main,
        color: palette.primary.main,
        marginTop: "1%",
        marginRight: "1%"
    },
    small: {
        width: theme.spacing(4),
        height: theme.spacing(4),
    },
    divButton: {
        paddingLeft: '3%',
        paddingRight: '3%'
    }
}));




export function PhysicalInvoiceOptions({ clearAllData, fechaEmision, factura, setFactura, detalles, pagos, additionalInfoInvoice, propina, idCliente, totals, physicalData, idempresacontratante }) {

    const classes = useStyles();
    const tokenUser = useSelector(state => state.user.tk);
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg] = React.useState("");
    const [openLoader, setOpenLoader] = React.useState(false);
    const dispatch = useDispatch();
    const selectedResource = (resource) => dispatch(selectedResourceAction(resource));
    const createFactura = () => {

        if (validation()) {
            let infoAdicional = [];
            if (idCliente.idAsignacionEmpresaCliente !== 0) {
                infoAdicional.push({ nombre: 'CORREO', valor: idCliente.correo })
                if (additionalInfoInvoice.length > 0) {
                    Array.prototype.push.apply(infoAdicional, additionalInfoInvoice);
                }
            } else {
                if (additionalInfoInvoice.length > 0) {
                    Array.prototype.push.apply(infoAdicional, additionalInfoInvoice);
                }
            }
            return ({
                detalles: detalles,
                //fechaEmision:fechaEmision.toISOString().substring(0, 10),
                fechaEmision: physicalData.fechaEmision,
                fechaAutorizacion: physicalData.fechaAutorizacion,
                numAutorizacion: physicalData.numAutorizacion,
                numeracion: physicalData.numeracion,
                idAsigancionEmpresaUsuario: Number(getSub(tokenUser)),
                idAsignacionEmpresaCliente: idCliente.idAsignacionEmpresaCliente,
                infromacionAdicional: infoAdicional,
                rucEmpresa: idempresacontratante,

            });

        } else {
            setOpenLoader(false);
            return null;
        }
    }

    const validatePrerequisities = (ride) => {
        const tk = tokenUser ? tokenUser : "";
        if (tk !== "") {
            setOpenLoader(true);
            checkPreRequirements(getSub(tk), getRUCEmpresa(tk), dispatch)
                .then((newErrorsCompany) => {
                    if (Array.isArray(newErrorsCompany)) {
                        if (newErrorsCompany.length === 0) {
                            if (ride) {
                                generateRide();
                            } else {
                                generateInvoice()
                            }
                        } else {
                            selectedResource({
                                "id": -4,
                                "nameMenu": "Verificando pre-requisitos",
                                "titlePage": "Verificando pre-requisitos",
                                titleTab: "Inicio",
                                "menuPadre": ""
                            })
                        }
                    }
                })
                .catch(() => {
                    //setShowLoader(false);
                    setOpenLoader(false);
                });
        }
    }


    //para generar la factura
    const generateInvoice = async () => {
        let invoice = createFactura();
        if (invoice !== null) {
            await httpCore.post(`/generacion/comprobantes/factura/fisica`, invoice).then(
                response => {
                    if (response.status === 200) {
                    }
                    //para actualizar el contador de comprobantes
                    //dispatch(getNumberVoucherSuccess(response.numeroComprobantesDisponibles));
                    //Para limpiar los datos del comprobante                    
                    clearAllData();
                    setOpenLoader(false);
                    /*selectedResource({
                        "id": -4,
                        "nameMenu": "Verificando pre-requisitos",
                        "titlePage": "Verificando pre-requisitos",
                        titleTab: "Inicio",
                        "menuPadre": ""
                    })*/
                    msmSwalExito(
                        "Comprobante guardado",

                    ).then((response) => {
                        if (response.isDismissed) {
                            selectedResource({
                                "id": "PEN",
                                "nameMenu": "Pendientes",
                                "titlePage": "Pendientes",
                                titleTab: "Comp. Pendientes",
                                "menuPadre": "REP"
                            })
                        }
                    });
                }
            ).catch(
                exception => {
                    if (exception.response) {

                        msmSwalError(exception.response.data.apierror ? exception.response.data.apierror.mensaje ? exception.response.data.apierror.mensaje : 'Error al generar el comprobante.' : 'Error al generar el comprobante.')

                    } else {

                        msmSwalError('Existen problemas en la red. Contáctese con el administrador del Sistema.')
                    }
                    setOpenLoader(false);
                }
            );

        }
    }

    const generateRide = async () => {
        let invoice = createFactura();
        if (invoice !== null) {
            setOpenLoader(true);
            //validatePrerequisities();
            return await clientBackendPDF.post(`/core/generacion/comprobantes/ride/factura/fisica`, invoice).then(
                response => {
                    //Create a Blob from the PDF Stream
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    //Build a URL from the file
                    const fileURL = URL.createObjectURL(file);
                    setOpenLoader(false);
                    //Open the URL on new Window
                    window.open(fileURL);
                    msmSwalExito('CAFE generado')
                }
            ).catch(
                exception => {
                    if (exception.response) {
                        console.error('error', { exception });
                        msmSwalError(exception.response.data.apierror ? exception.response.data.apierror.mensaje ? exception.response.data.apierror.mensaje : 'Error al generar el comprobante.' : 'Error al generar el comprobante.')
                    } else {
                        msmSwalError('Existe problemas en la red. Contáctese con el administrador del Sistema.')
                    }
                    setOpenLoader(false);
                }
            )
        }
    }

    const validation = () => {
        let result = true;
        const errors = {}
        if (typeof physicalData.numeracion === 'undefined' || physicalData.numeracion.trim() === '' || physicalData.numeracion.trim().replace("_", '').trim().length < 17) {
            errors.numeracion = 'Ingrese la numeración';
            result = false;
        }
        if (typeof physicalData.fechaEmision === 'undefined' || physicalData.fechaEmision === '') {
            errors.fechaEmision = 'Ingrese la fecha de emisión';
            result = false;
        }
        if (typeof physicalData.fechaAutorizacion === 'undefined' || physicalData.fechaAutorizacion === '') {
            errors.fechaAutorizacion = 'Ingrese la fecha de autorización';
            result = false;
        }
        if (typeof physicalData.numAutorizacion === 'undefined' || physicalData.numAutorizacion.trim() === '' || physicalData.numAutorizacion.trim().replace("_", '').trim().length < 10) {
            errors.numAutorizacion = 'Ingrese la Autorización No.';
            result = false;
        }
        if (Object.entries(idCliente).length === 0) {
            errors.cliente = 'Ingrese el proveedor';
            result = false;
        }
        ErrorsAlert(errors)
        return result;
    }




    const handleClose = () => {
        setOpen(false);
    };

    const clearForm = () => {
        ConfirmAlert(
            `¿Está seguro de limpiar los datos del formulario?`,
            "",
            iconsAlert.question,
            true,
            "Sí",
            "Cancelar",
            () => {
                clearAllData();
            },
            () => {

            }
        );
    }

    return (
        <Fragment >

            <div className={classes.root} justifyContent='absolute'>

                <Grid item xs={12} md={4} align="center" className={classes.divButton} >
                    <Button onClick={() => validatePrerequisities(true)} variant="text" className={classes.btnReport} fullWidth>
                        <Avatar variant="square" src={pdfIcon} className={classes.small} />
                        Visualizar Factura
                    </Button>
                </Grid>
                <Grid item xs={12} md={4} align="center" className={classes.divButton}>
                    <Button onClick={() => validatePrerequisities(false)} variant="text" className={classes.btnReport} fullWidth>
                        <SaveIcon style={{ color: palette.info.main }} fontSize="large" />
                        Guardar
                    </Button>
                </Grid>

                <Grid item xs={12} md={4} align="center">
                    <Button
                        onClick={clearForm}
                        variant="text"
                        className={classes.btnReport}
                        fullWidth
                    >
                        <DeleteSweepIcon style={{ color: palette.error.main, marginRight: "10px" }} fontSize="large" />
                        Limpiar Formulario
                    </Button>
                </Grid>

                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={open}
                    onClose={handleClose}
                >
                    <DialogTitle >Advertencia</DialogTitle>
                    <DialogContent>

                        <Grid container spacing={0}>
                            <Grid item xs={12} md={12} className={classes.msgDialog} align="center">
                                {msg}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Button variant="contained" color="primary" fullWidth
                                    onClick={handleClose}
                                >Cerrar</Button>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
                <Backdrop className={classes.backdrop} open={openLoader} >
                    <CircularProgress color="primary" />
                </Backdrop>
            </div>

        </Fragment>

    );
}

